import ApiService from "./ApiService"

const Service = new ApiService()

export const getAllTeams = async() => Service.getData("/teams")

export const deleteTeam = async(id) => Service.deleteTeam(`/teams/${id}`)